import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'

export const MinimizedOptions = () => {
  const optionId = InputProvider.useOptionId('optional')
  const option = VentrataDataProvider.useOption(optionId, 'optional')

  return <div className="text-end">{option ? option.title : null}</div>
}
